module.exports = __webpack_public_path__ + "e2865f1ac59fc660ce9ad52d592d0683.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/drumsticks.png
// module id = 2837
// module chunks = 0